<template>
  <div class="departmentDetail">
    <!--部门信息-->
    <el-form ref="departmentDetail" label-position="right" label-width="100px" :model="detail">
      <el-row v-if="flag !== 'intersetGroup'" :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.departmentCode')">
            <el-input v-model="detail.createDepartmentCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.departmentName')">
            <el-input v-model="detail.createDepartmentName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.receiptClaimMode')" prop="receiptClaimMode">
            <el-select
              filterable
              class="inputWidth"
              v-model="detail.receiptClaimMode"
              clearable
              disabled
            >
              <el-option
                v-for="item of receiptClaimModeList"
                style="width: 100%"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')">
            <el-input-number
              v-model="detail.sortOrder"
              :controls="false"
              class="inputWidth"
              :min="0"
              :max="999"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-else :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.departmentCode')">
            <el-input v-model="detail.interestDepartmentCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.departmentName')">
            <el-input v-model="detail.interestDepartmentName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调整部门组日期">
            <el-input v-model="detail.inDate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="离开部门组日期">
            <el-input v-model="detail.outDate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门组编码">
            <el-input v-model="detail.interestGroupCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门组名称">
            <el-input v-model="detail.interestGroupName" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--上级单位-->
    <div v-if="flag !== 'intersetGroup'" class="department-content">{{
      this.$t('company.higherDepartmentTitle')
    }}</div>
    <sirui-table
      v-if="flag !== 'intersetGroup'"
      ref="unitTable"
      :buttonList="[]"
      :loading="false"
      :data="unitData"
      :paging="false"
      :setting="false"
      :reserve="false"
    >
      <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in unitColumnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </sirui-table>
    <!--控制范围-->
    <div class="department-content control-content">{{
      flag == 'intersetGroup' ? '该部门所有部门组' : this.$t('company.controlTitle')
    }}</div>
    <sirui-table
      ref="siruiTable"
      :buttonList="[]"
      :loading="false"
      :data="tableData"
      :paging="false"
      :setting="false"
      :reserve="false"
    >
      <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </sirui-table>
  </div>
</template>
<script>
  // import API from '@/api/masterData/company.js';
  import SiruiTable from '@/components/SiruiTable';

  export default {
    name: 'departmentDetail',
    components: {
      SiruiTable,
    },
    data() {
      return {};
    },
    props: {
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
      detail: {
        type: Object,
        default: () => {},
      },
      unitData: {
        type: Array,
        default: () => [],
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      flag: {
        type: String,
        default: () => '',
      },
    },
    computed: {
      unitColumnList() {
        return [
          {
            prop: 'superiorUnit',
            label: this.$t('company.table.unitName'),
          },
        ];
      },
      columnList() {
        return this.flag == 'intersetGroup'
          ? [
              {
                prop: 'interestGroupName',
                label: '部门组',
              },
            ]
          : [
              {
                prop: 'controlAreaName',
                label: this.$t('company.table.controlareaName'),
              },
            ];
      },
    },
    mounted() {},
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
  .control-content {
    margin-top: 10px;
  }
</style>
